import { render } from "./UserInTree.vue?vue&type=template&id=444e6256"
import script from "./UserInTree.vue?vue&type=script&lang=js"
export * from "./UserInTree.vue?vue&type=script&lang=js"
script.render = render

export default script